import { lazy } from 'react'

export const BenefitsVariant2 = lazy(() => import('./BenefitsVariant2'))
